import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgSuccessCircle = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16.08 9.975a.75.75 0 0 0-1.16-.95l-3.734 4.563a.25.25 0 0 1-.385.002l-1.725-2.07a.75.75 0 0 0-1.152.96l1.725 2.07a1.75 1.75 0 0 0 2.698-.012z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20M8.747 4.147a8.5 8.5 0 1 1 6.506 15.706A8.5 8.5 0 0 1 8.747 4.147"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgSuccessCircle;
